import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutType } from '../utils/enums';
import { keycloak } from '../auth/keycloak';

type UnauthorizedProps = {
    page: React.ReactElement;
    layout?: LayoutType;
};
export const Unauthorized: React.FC<UnauthorizedProps> = ({ page }) => {
    const navigate = useNavigate();

    const [pageContent, setPageContent] = React.useState<React.ReactElement>(
        <></>
    );
    React.useEffect(() => {
        if (keycloak.authenticated) {
            navigate('/work-order');
        } else {
            setPageContent(page);
        }
    }, [page, navigate]);

    return <>{pageContent}</>;
};
